/**
 * components/slider.tsx — 0..1 range control (Settings → Advanced ignored_weight).
 * Web renders a native range input (accent-color ink, matching the design);
 * native falls back to a stepped −/+ control so there's no extra dependency.
 */
import React from 'react';
import { Platform, View, Pressable } from 'react-native';
import { LightColors as C } from '../theme/theme';
import { Txt } from './ui';

export interface SliderProps {
  value: number;
  onChange: (v: number) => void;
  min?: number;
  max?: number;
  step?: number;
}

const Slider: React.FC<SliderProps> = ({ value, onChange, min = 0, max = 1, step = 0.1 }) => {
  if (Platform.OS === 'web') {
    return React.createElement('input', {
      type: 'range',
      min,
      max,
      step,
      value,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) => onChange(Number(e.target.value)),
      style: { width: '100%', accentColor: C.ink, cursor: 'pointer' },
    });
  }
  const dec = () => onChange(Math.max(min, Math.round((value - step) * 10) / 10));
  const inc = () => onChange(Math.min(max, Math.round((value + step) * 10) / 10));
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 12 }}>
      <Pressable onPress={dec} style={{ width: 28, height: 28, borderRadius: 5, borderWidth: 1, borderColor: C.line, alignItems: 'center', justifyContent: 'center' }}>
        <Txt size={16} color={C.ink2}>
          −
        </Txt>
      </Pressable>
      <View style={{ flex: 1, height: 6, borderRadius: 999, backgroundColor: C.paper3 }}>
        <View style={{ width: `${((value - min) / (max - min)) * 100}%`, height: '100%', borderRadius: 999, backgroundColor: C.ink }} />
      </View>
      <Pressable onPress={inc} style={{ width: 28, height: 28, borderRadius: 5, borderWidth: 1, borderColor: C.line, alignItems: 'center', justifyContent: 'center' }}>
        <Txt size={16} color={C.ink2}>
          +
        </Txt>
      </Pressable>
    </View>
  );
};

export default Slider;
